module.exports = __webpack_public_path__ + "static/appetizer-2c7696b99d5020cdace04b6d33384824.png";